import http, { API_PREFIX } from '@/services/http'

export interface KeycloakLoginResponse {
  auth_url: string
  state: string
  code_verifier: string
  redirect_uri: string
  signature?: string
  ts?: number
}

export interface KeycloakCallbackRequest {
  code: string
  state: string
  code_verifier: string
  redirect_uri: string
  signature?: string
  ts?: number
}

export interface KeycloakLogoutResponse {
  logout_url: string
}

export interface TokenValidationResponse {
  valid: boolean
  user_info?: any
  token_type?: string
  expires_at?: string
  error?: string
}

export const keycloakApi = {
  /**
   * Initiate Keycloak login flow
   */
  async initiateLogin(redirectUri?: string): Promise<KeycloakLoginResponse> {
    const params = new URLSearchParams()
    if (redirectUri) {
      params.append('redirect_uri', redirectUri)
    }
    
    const response = await http.get(`${API_PREFIX}/auth/keycloak/login?${params.toString()}`)
    return response.data
  },

  /**
   * Handle Keycloak callback and exchange code for tokens
   */
  async handleCallback(callbackData: KeycloakCallbackRequest) {
    const response = await http.post(`${API_PREFIX}/auth/keycloak/callback`, callbackData)
    return response.data
  },

  /**
   * Get Keycloak logout URL
   */
  async getLogoutUrl(redirectUri?: string): Promise<KeycloakLogoutResponse> {
    const params = new URLSearchParams()
    if (redirectUri) {
      params.append('redirect_uri', redirectUri)
    }
    
    const response = await http.get(`${API_PREFIX}/auth/keycloak/logout?${params.toString()}`)
    return response.data
  },

  /**
   * Validate JWT token
   */
  async validateToken(token: string, tokenType: string = 'auto'): Promise<TokenValidationResponse> {
    const response = await http.post(`${API_PREFIX}/auth/validate-token`, {
      token,
      token_type: tokenType
    })
    return response.data
  }
}